import { get } from 'lodash'

import {
  SET_PROFILE,
  statusType
} from '../../actions'

const initial = {
  data: {},
  token: '',
  status: statusType.IDLE
}

const profile = (state = initial, action) => {
  const { payload } = action

  switch (action.type) {
    case SET_PROFILE:
      return {
        data: payload.profile,
        token: payload.token,
        userId: get(payload, 'profile.user_id', '').split('|')[1],
        status: statusType.SUCCESS
      }

    default:
      return state
  }
}

export default profile
